"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Logout = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tokens = require("../../utils/tokens");

var _hooks = require("../../hooks");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * TODO V5 remove history and redirectTo props in favor of an `after` prop
 */


var Logout = function Logout(props) {
  var history = props.history,
      redirectTo = props.redirectTo,
      before = props.before,
      after = props.after;
  var authManager = (0, _hooks.useAuthManager)();
  (0, _react.useEffect)(function () {
    // if a before fn was provided, execute it
    if (before !== null) {
      before();
    } // if we have valid tokens, run authManager sign out process


    if (authManager !== null && (0, _tokens.isTokensValid)(authManager.getTokens())) {
      authManager.signOut("".concat(authManager.config.logoutPath));
      return;
    } // TODO V5 remove this logic in favor of using after() prop


    if (history && redirectTo) {
      history.push(redirectTo);
    } // if an after fn was provided, execute it


    if (after !== null) {
      after();
    }
  }, []);
  return null;
};

exports.Logout = Logout;
Logout.propTypes = {
  redirectTo: _propTypes.default.string,
  history: _propTypes.default.shape({}),
  // an optional function that can be used to run app specific logout process before logging the
  // user out
  before: _propTypes.default.func,
  // an optional function that can be used to run after the logout logic is completed
  after: _propTypes.default.func
};
Logout.defaultProps = {
  history: null,
  redirectTo: null,
  before: null,
  after: null
};
var _default = Logout;
exports.default = _default;